/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".labels[_ngcontent-%COMP%]{\r\n    padding-top: 20px;\r\n}\r\n.titulos[_ngcontent-%COMP%]{\r\n    padding-bottom: 20px; \r\n    margin-top: 20px;\r\n    -webkit-text-decoration-line: underline;\r\n            text-decoration-line: underline;\r\n}"];
export { styles as styles };
